import { getTimeAgo } from "src/utils/date.util";
import { Badge } from "src/components/Badge/Badge";
import { PostWithUser } from "../../types/index.type";
import {
  getPostTypeIcon,
  getPostTypeBadgeClasses,
  getVisibilityIcon,
  getVisibilityBadgeClasses,
} from "../../utils/posts-style";
import { LuClock as Clock } from "react-icons/lu";
// Post Meta Component
type PostMetaProps = {
  post: PostWithUser["post"];
};

export const PostMeta = ({ post }: PostMetaProps) => {
  return (
    <div className="flex items-center gap-4 text-sm">
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-1.5">
          {getPostTypeIcon(post.type)}
          <Badge
            classes={`${getPostTypeBadgeClasses(post.type)} font-medium px-2.5 py-1 rounded-full text-xs`}
            label={post.type.replace("_", " ")}
          />
        </div>

        <div className="flex items-center gap-1.5">
          {getVisibilityIcon(post.visibility)}
          <Badge
            classes={`${getVisibilityBadgeClasses(post.visibility)} font-medium px-2.5 py-1 rounded-full text-xs`}
            label={post.visibility}
          />
        </div>
      </div>

      <div className="flex items-center gap-4 text-gray-500">
        <div className="flex items-center gap-1.5">
          <Clock className="h-4 w-4" />
          <span className="font-medium">{getTimeAgo(post.createdAt)}</span>
        </div>
        <div className="flex items-center gap-1">
          {post.langCodes?.map((code) => (
            <div key={code} className="px-2 py-1 bg-gray-100 rounded-full text-xs font-semibold text-gray-600">
              {code.toUpperCase()}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
